import { render, staticRenderFns } from "./ListPrestamos.vue?vue&type=template&id=0f5f154c&"
import script from "./ListPrestamos.vue?vue&type=script&lang=js&"
export * from "./ListPrestamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports